import type { ResourcesConfig } from "aws-amplify";
import type { RuntimeConfig } from "nuxt/schema";
import { getModule } from "vuex-module-decorators";

import { store } from "~/store";
import PlatformModule from "~/store/PlatformModule";

import type { AuthProvider } from "./app/types/Auth";

/**
 * This configuration was made with the the following spec/documentation:
 * https://docs.amplify.aws/gen1/react/tools/libraries/configure-categories/#general-configuration
 */

export default (
  runtimeConfig: RuntimeConfig,
  customProviders: AuthProvider[],
) => {
  const platformStore = getModule(PlatformModule, store);
  const host = window !== undefined ? window.location.origin : "";

  let cognitoConfig = runtimeConfig.public.cognito.mws;
  if (platformStore.isFrameTheGame) {
    cognitoConfig = runtimeConfig.public.cognito.ftg;
  } else if (getIsHostLiverpool()) {
    cognitoConfig = runtimeConfig.public.cognito.lfc;
  }

  return {
    Auth: {
      Cognito: {
        userPoolId: cognitoConfig.userPool.id,
        userPoolClientId: cognitoConfig.userPool.clientId,
        userPoolEndpoint: cognitoConfig.userPool.endpoint,
        identityPoolId: "",
        loginWith: {
          email: true,
          oauth: {
            providers: ["Google", "Apple", ...customProviders],
            domain: cognitoConfig.domain.replace("https://", ""),
            redirectSignIn: [`${host}/auth-redirect`],
            redirectSignOut: [`${host}/`],
            responseType: "code",
            scopes: ["email", "profile"],
          },
        },
        signUpVerificationMethod: "code",
        userAttributes: {
          email: {
            required: true,
          },
        },
        allowGuestAccess: true,
        passwordFormat: {
          minLength: 8,
          requireLowercase: true,
          requireUppercase: true,
          requireNumbers: true,
          requireSpecialCharacters: true,
        },
      },
    },
  } satisfies ResourcesConfig;
};
